import React from "react";
import NotificationCard from "./NotificationCard";

export const ToastContext = React.createContext({
  notify: (text, opts) => {},
});

export default function ToastProvider({ children }) {
  const [toasts, setToasts] = React.useState([]); // {id, text, type, actionText, onAction, duration}

  const remove = React.useCallback((id) => {
    setToasts((list) => list.filter((t) => t.id !== id));
  }, []);

  const notify = React.useCallback((text, opts = {}) => {
    const id = Math.random().toString(36).slice(2);
    const toast = {
      id,
      text: String(text || ""),
      type: opts.type || "info", // info | success | error
      actionText: opts.actionText,
      onAction: opts.onAction,
      duration: typeof opts.duration === "number" ? opts.duration : 4000,
    };
    setToasts((list) => [...list, toast]);
    if (toast.duration > 0) {
      setTimeout(() => remove(id), toast.duration);
    }
    return id;
  }, [remove]);

  const value = React.useMemo(() => ({ notify }), [notify]);

  return (
    <ToastContext.Provider value={value}>
      {children}
      {/* Container: absolute center with translate (more reliable on mobile) */}
      <div className="fixed left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 z-[999] pointer-events-none w-[min(92vw,420px)] max-h-[80vh] overflow-auto p-0">
        <div className="space-y-2">
          {toasts.map((t) => (
            <div key={t.id} className="pointer-events-auto">
              <NotificationCard
                type={t.type}
                dismissible={true}
                onDismiss={() => remove(t.id)}
                className="mb-0"
              >
                <div className="flex items-start justify-between gap-3">
                  <div className="flex-1 whitespace-pre-wrap text-sm">{t.text}</div>
                  {t.actionText && t.onAction && (
                    <button
                      className="btn btn-sm btn-outline flex-shrink-0"
                      onClick={() => { try { t.onAction(); } catch {} remove(t.id); }}
                    >
                      {t.actionText}
                    </button>
                  )}
                </div>
              </NotificationCard>
            </div>
          ))}
        </div>
      </div>
    </ToastContext.Provider>
  );
}
